"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LiveTitle = exports.getStreamersName = exports.StreamersAvatar = exports.HeadlineStreamerItem = exports.HeadlineTextItem = exports.ElementsDivisor = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Avatar = require("../Avatar");

var _Typography = require("../Typography");

var StyledLiveText = (0, _styledComponents.default)(_Typography.Text).withConfig({
  displayName: "StyledElements__StyledLiveText",
  componentId: "sc-1xbcbuk-0"
})((0, _css.default)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexShrink: 0
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    tiny: {
      fontSize: [1],
      lineHeight: [3, 2]
    },
    small: {
      fontSize: [1],
      lineHeight: [3, 2]
    },
    medium: {
      fontSize: [1],
      lineHeight: [3, 2]
    },
    large: {
      fontSize: [2],
      lineHeight: [5, 4]
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'fontColor',
  variants: {
    dark: {
      color: 'castana'
    },
    light: {
      color: 'coco'
    }
  }
}));
var StyledStreamerText = (0, _styledComponents.default)(StyledLiveText).withConfig({
  displayName: "StyledElements__StyledStreamerText",
  componentId: "sc-1xbcbuk-1"
})((0, _css.default)({
  flexShrink: 1
}), (0, _styledSystem.variant)({
  prop: 'fontColor',
  variants: {
    dark: {
      color: 'sonar'
    },
    light: {
      color: 'coco'
    }
  }
}));
var StyledLiveTitle = (0, _styledComponents.default)(_Typography.Text).withConfig({
  displayName: "StyledElements__StyledLiveTitle",
  componentId: "sc-1xbcbuk-2"
})({
  '-webkit-line-clamp': function webkitLineClamp(_ref) {
    var maxLines = _ref.maxLines;
    return maxLines;
  }
}, (0, _css.default)({
  display: '-webkit-box',
  '-webkit-box-orient': 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontWeight: 'medium',
  flexGrow: 1,
  flexShrink: 0
}), (0, _styledSystem.variant)({
  prop: 'size',
  variants: {
    tiny: {
      fontSize: [3, 3, 4],
      lineHeight: [6]
    },
    small: {
      fontSize: [4],
      lineHeight: [6]
    },
    medium: {
      fontSize: [5, 5, 6],
      lineHeight: [8, 6, 8]
    },
    large: {
      fontSize: [8, 7, 9],
      lineHeight: [10, 9, 13]
    }
  }
}), (0, _styledSystem.variant)({
  prop: 'fontColor',
  variants: {
    dark: {
      color: 'sonar',
      ':hover': {
        color: 'rambutan'
      }
    },
    light: {
      color: 'coco'
    }
  }
}));
var StyledAvatar = (0, _styledComponents.default)(_Avatar.Avatar).withConfig({
  displayName: "StyledElements__StyledAvatar",
  componentId: "sc-1xbcbuk-3"
})((0, _css.default)({
  div: {
    border: '1px solid',
    borderColor: 'durian'
  }
}));

var ElementsDivisor = function ElementsDivisor(props) {
  return _react.default.createElement(StyledLiveText, (0, _extends2.default)({
    color: "coco",
    marginX: 1
  }, props), "\xB7");
};

exports.ElementsDivisor = ElementsDivisor;

var HeadlineTextItem = function HeadlineTextItem(_ref2) {
  var text = _ref2.text,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["text"]);
  return _react.default.createElement(StyledLiveText, props, text);
};

exports.HeadlineTextItem = HeadlineTextItem;

var HeadlineStreamerItem = function HeadlineStreamerItem(_ref3) {
  var text = _ref3.text,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["text"]);
  return _react.default.createElement(StyledStreamerText, props, text);
};

exports.HeadlineStreamerItem = HeadlineStreamerItem;

var StreamersAvatar = function StreamersAvatar(_ref4) {
  var streamers = _ref4.streamers;
  return streamers.map(function (_ref5, index) {
    var avatar = _ref5.avatar;
    return _react.default.createElement(StyledAvatar, {
      key: "dmstk-live-card-info-avatar-".concat(index + 1),
      src: avatar,
      size: "tiny",
      marginLeft: index > 0 ? '-12px' : '0'
    });
  });
};

exports.StreamersAvatar = StreamersAvatar;

var getStreamersName = function getStreamersName(_ref6) {
  var streamers = _ref6.streamers;
  return streamers.map(function (_ref7) {
    var name = _ref7.name;
    return name;
  }).join(', ');
};

exports.getStreamersName = getStreamersName;

var LiveTitle = function LiveTitle(_ref8) {
  var text = _ref8.text,
      maxLines = _ref8.maxLines,
      props = (0, _objectWithoutProperties2.default)(_ref8, ["text", "maxLines"]);
  return _react.default.createElement(StyledLiveTitle, (0, _extends2.default)({
    maxLines: maxLines,
    marginTop: 2
  }, props), text);
};

exports.LiveTitle = LiveTitle;
LiveTitle.defaultProps = {
  maxLines: 2
};